<div fxLayout *ngIf="{ policies: policies$ | async, policiesError: policiesError$ | async } as vm">
  <sbnb-subnav header="Direct">
    <sbnb-direct-subnav></sbnb-direct-subnav>
  </sbnb-subnav>

  <main fxFlex [ngClass.lt-md]="{ mobile: true }" class="subnav__exists" fxLayout="column" fxLayoutGap="32px">
    <ng-container *ngTemplateOutlet="headerSection"></ng-container>

    <!-- Loading -->
    <ng-container *ngTemplateOutlet="loadingSection; context: { vm: vm }"></ng-container>

    <!-- Error -->
    <ng-container *ngTemplateOutlet="errorSection; context: { vm: vm }"></ng-container>

    <!-- No policies created yet -->
    <ng-container *ngTemplateOutlet="noPoliciesSection; context: { vm: vm }"></ng-container>

    <!-- Happy path - we have policies -->
    <section *ngIf="vm.policies?.length > 0">
      <div fxLayout fxLayoutGap="12px" fxHide.lt-md class="rules__rule-header">
        <div fxFlex="30">Name</div>
        <div fxFlex="35">Refunds</div>
        <div fxFlex="35">Payments</div>
        <div fxFlex="140px">Properties</div>
      </div>

      <a
        *ngFor="let policy of vm.policies"
        class="rules__rule-container"
        fxLayout
        fxLayoutAlign="start center"
        fxLayoutGap="12px"
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start start"
        [routerLink]="['/direct/booking-policies', policy.uuid]">
        <strong fxFlex="30">{{ policy.name }}</strong>

        <div fxFlex="35" fxLayout="column" fxLayoutGap="8px">
          <ng-container *ngFor="let term of policy.terms">
            <span
              *ngIf="
                term.enabled &&
                (term.type === CancellationTermType.AfterBooking ||
                  term.type === CancellationTermType.BeforeCheckIn ||
                  term.type === CancellationTermType.UntilCheckIn)
              "
              class="text__small">
              {{ term.label }}
            </span>
          </ng-container>
        </div>

        <div fxFlex="35" fxLayout="column" fxLayoutGap="8px">
          <ng-container [ngSwitch]="policy.payment_terms_status">
            <ng-container *ngSwitchCase="PaymentTermStatus.Aligned">
              <span class="text__small">Payment terms aligned with cancellation policy</span>
            </ng-container>

            <ng-container *ngSwitchCase="PaymentTermStatus.Manual">
              <span class="text__small">Custom payment schedule</span>
            </ng-container>

            <ng-container *ngSwitchCase="PaymentTermStatus.Disabled">
              <span class="text__small">Guests always pay 100% upfront</span>
            </ng-container>
          </ng-container>

          <ng-container *ngIf="isPremium$ | async">
            <ng-container [ngSwitch]="policy.host_only_service_fee_enabled">
              <ng-container *ngSwitchCase="true">
                <span class="text__small">7% host service fee</span>
              </ng-container>
              <ng-container *ngSwitchCase="false">
                <span class="text__small">4% guest service fee + 3% host service fee</span>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>

        <div fxFlex="140px" fxFlex.lt-md="auto" fxLayoutAlign="start center">
          <sbnb-avatar-group
            fxHide.lt-md
            [items]="policy.property_list"
            [allItems]="policy.default"
            [itemsForLabel]="policy.name"
            allItemsLabel="Default"
            [expandAllItems]="true"></sbnb-avatar-group>
        </div>
      </a>
    </section>
  </main>
</div>

<ng-template #headerSection>
  <section id="header" fxLayout="column">
    <app-feature-flag-tabs>
      <ng-container navTabs>
        <sbnb-page-header class="block sbnbDesktop:hidden !mb-0"></sbnb-page-header>
        <div fxLayout>
          <h2 class="nomargin" fxFlex>Booking Policy Manager</h2>
          <sbnb-button size="mini" (clicked)="createNewCancellationPolicy()">
            +
            <span class="hidden sbnbDesktop:inline-block">&nbsp;Add new</span>
          </sbnb-button>
        </div>
      </ng-container>
      <div fxLayout>
        <h2 class="nomargin" fxFlex>Booking Policy Manager</h2>
        <sbnb-button size="mini" (clicked)="createNewCancellationPolicy()">+ Add new</sbnb-button>
      </div>
    </app-feature-flag-tabs>

    <sbnb-helptext-wrapper
      class="helptext-wrapper-type-content"
      [area]="'content'"
      [pageId]="'direct-booking-policies'"></sbnb-helptext-wrapper>
  </section>
</ng-template>

<ng-template #loadingSection let-vm="vm">
  <ng-container *ngIf="vm.policies === null && !vm.policiesError">
    <mat-spinner [diameter]="32"></mat-spinner>
  </ng-container>
</ng-template>

<ng-template #errorSection let-vm="vm">
  <ng-container *ngIf="vm.policiesError">There was an error loading booking policies.</ng-container>
</ng-template>

<ng-template #noPoliciesSection let-vm="vm">
  <ng-container *ngIf="vm.policies?.length === 0 && !vm.policiesError">
    <sbnb-no-items text="No booking policies" subtext="You haven’t created any booking policies yet."></sbnb-no-items>
  </ng-container>
</ng-template>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Direct">
  <sbnb-direct-subnav></sbnb-direct-subnav>
</sbnb-mobile-sidebar>
